var map = {
	"./ion-action-sheet-controller.entry.js": [
		785,
		85
	],
	"./ion-action-sheet-ios.entry.js": [
		786,
		63
	],
	"./ion-action-sheet-md.entry.js": [
		787,
		64
	],
	"./ion-alert-controller.entry.js": [
		788,
		86
	],
	"./ion-alert-ios.entry.js": [
		789,
		48
	],
	"./ion-alert-md.entry.js": [
		790,
		49
	],
	"./ion-anchor_2-ios.entry.js": [
		791,
		65
	],
	"./ion-anchor_2-md.entry.js": [
		792,
		66
	],
	"./ion-app_7-ios.entry.js": [
		793,
		26
	],
	"./ion-app_7-md.entry.js": [
		794,
		27
	],
	"./ion-avatar_3-ios.entry.js": [
		795,
		67
	],
	"./ion-avatar_3-md.entry.js": [
		796,
		68
	],
	"./ion-backdrop-ios.entry.js": [
		797,
		46
	],
	"./ion-backdrop-md.entry.js": [
		798,
		47
	],
	"./ion-button_2-ios.entry.js": [
		799,
		28
	],
	"./ion-button_2-md.entry.js": [
		800,
		29
	],
	"./ion-card_5-ios.entry.js": [
		801,
		69
	],
	"./ion-card_5-md.entry.js": [
		802,
		70
	],
	"./ion-checkbox-ios.entry.js": [
		803,
		30
	],
	"./ion-checkbox-md.entry.js": [
		804,
		31
	],
	"./ion-chip-ios.entry.js": [
		805,
		71
	],
	"./ion-chip-md.entry.js": [
		806,
		72
	],
	"./ion-col_3.entry.js": [
		807,
		87
	],
	"./ion-datetime_4-ios.entry.js": [
		808,
		18
	],
	"./ion-datetime_4-md.entry.js": [
		809,
		19
	],
	"./ion-fab_3-ios.entry.js": [
		810,
		73
	],
	"./ion-fab_3-md.entry.js": [
		811,
		74
	],
	"./ion-img.entry.js": [
		812,
		88
	],
	"./ion-infinite-scroll_2-ios.entry.js": [
		813,
		59
	],
	"./ion-infinite-scroll_2-md.entry.js": [
		814,
		60
	],
	"./ion-input-ios.entry.js": [
		815,
		32
	],
	"./ion-input-md.entry.js": [
		816,
		33
	],
	"./ion-item-option_3-ios.entry.js": [
		817,
		34
	],
	"./ion-item-option_3-md.entry.js": [
		818,
		35
	],
	"./ion-item_8-ios.entry.js": [
		819,
		75
	],
	"./ion-item_8-md.entry.js": [
		820,
		76
	],
	"./ion-loading-controller.entry.js": [
		821,
		89
	],
	"./ion-loading-ios.entry.js": [
		822,
		50
	],
	"./ion-loading-md.entry.js": [
		823,
		51
	],
	"./ion-menu_4-ios.entry.js": [
		824,
		24
	],
	"./ion-menu_4-md.entry.js": [
		825,
		25
	],
	"./ion-modal-controller.entry.js": [
		826,
		90
	],
	"./ion-modal-ios.entry.js": [
		827,
		14
	],
	"./ion-modal-md.entry.js": [
		828,
		15
	],
	"./ion-nav_4.entry.js": [
		829,
		12
	],
	"./ion-popover-controller.entry.js": [
		830,
		91
	],
	"./ion-popover-ios.entry.js": [
		831,
		16
	],
	"./ion-popover-md.entry.js": [
		832,
		17
	],
	"./ion-progress-bar-ios.entry.js": [
		833,
		36
	],
	"./ion-progress-bar-md.entry.js": [
		834,
		37
	],
	"./ion-radio_2-ios.entry.js": [
		835,
		38
	],
	"./ion-radio_2-md.entry.js": [
		836,
		39
	],
	"./ion-range-ios.entry.js": [
		837,
		40
	],
	"./ion-range-md.entry.js": [
		838,
		41
	],
	"./ion-refresher_2-ios.entry.js": [
		839,
		61
	],
	"./ion-refresher_2-md.entry.js": [
		840,
		62
	],
	"./ion-reorder_2-ios.entry.js": [
		841,
		57
	],
	"./ion-reorder_2-md.entry.js": [
		842,
		58
	],
	"./ion-ripple-effect.entry.js": [
		843,
		92
	],
	"./ion-route_4.entry.js": [
		844,
		13
	],
	"./ion-searchbar-ios.entry.js": [
		845,
		22
	],
	"./ion-searchbar-md.entry.js": [
		846,
		23
	],
	"./ion-segment_2-ios.entry.js": [
		847,
		77
	],
	"./ion-segment_2-md.entry.js": [
		848,
		78
	],
	"./ion-select_3-ios.entry.js": [
		849,
		42
	],
	"./ion-select_3-md.entry.js": [
		850,
		43
	],
	"./ion-slide_2-ios.entry.js": [
		851,
		55
	],
	"./ion-slide_2-md.entry.js": [
		852,
		56
	],
	"./ion-spinner.entry.js": [
		853,
		79
	],
	"./ion-split-pane-ios.entry.js": [
		854,
		93
	],
	"./ion-split-pane-md.entry.js": [
		855,
		94
	],
	"./ion-tab-bar_2-ios.entry.js": [
		856,
		80
	],
	"./ion-tab-bar_2-md.entry.js": [
		857,
		81
	],
	"./ion-tab_2.entry.js": [
		858,
		54
	],
	"./ion-text.entry.js": [
		859,
		82
	],
	"./ion-textarea-ios.entry.js": [
		860,
		44
	],
	"./ion-textarea-md.entry.js": [
		861,
		45
	],
	"./ion-toast-controller.entry.js": [
		862,
		95
	],
	"./ion-toast-ios.entry.js": [
		863,
		52
	],
	"./ion-toast-md.entry.js": [
		864,
		53
	],
	"./ion-toggle-ios.entry.js": [
		865,
		20
	],
	"./ion-toggle-md.entry.js": [
		866,
		21
	],
	"./ion-virtual-scroll.entry.js": [
		867,
		96
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 765;
module.exports = webpackAsyncContext;